<template>
  <div class="metadata-container" @click="openLink">
    <img v-if="image" class="image" :src="image" alt="link-metadata-image" />
    <div class="details">
      <h3 v-if="title" class="title">
        {{ title }}
      </h3>
      <p v-if="description" class="description">
        {{ description }}
      </p>
    </div>
    <button v-if="removeMeta" @click="close" class="close-button">
      <img src="@/assets/CloseMed.svg" alt="close-button-icon" />
    </button>
  </div>
</template>
<script>
export default {
  name: 'LinkMetadataCover',
  props: {
    url: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    image: {
      type: String,
      default: null
    },
    removeMeta: {
      type: Function,
      default: null
    }
  },
  methods: {
    close(e) {
      e.stopPropagation()
      this.removeMeta()
    },
    openLink() {
      window.open(this.url, '_blank')
    }
  }
}
</script>
<style scoped lang="scss">
.metadata-container {
  background-color: #F2F2F2;
  border: 1px solid $secondary-color;
  border-radius: 9px;
  overflow: hidden;
  cursor: pointer;
  position: relative;

  &:hover > .close-button {
    visibility: visible;
  }
}

.image {
  object-fit: cover;
  width: 100%;
  height: 320px;
  display: block;
}

.details {
  padding: 9px;
  text-align: start;

  &>:first-child {
    margin-top: 0;
  }
  &>:last-child {
    margin-bottom: 0;
  }
}

.close-button {
  visibility: hidden;
  position: absolute;
  top: 3px;
  right: 3px;
  width: 40px;
  height: 40px;
  border-radius: 40px;
  border: 2px solid $primary-color;
  cursor: pointer;
}
</style>
